import{__require as e}from"../classes/range.js";const s=e();var r=(e,r,a)=>(e=new s(e,a),r=new s(r,a),e.intersects(r,a));export{r as i};
